const types = {
    Administrator: "Administrator",
    StockAdministrator: "StockAdministrator",
    MarketAdministrator: "MarketAdministrator",
    Manager: "Manager",
    Scanner: "Scanner",
    ReturnAdministrator: "ReturnAdministrator",
}

export default types;


// WEBPACK FOOTER //
// ./src/models/roleTypes.js